import type { NavigationGuard } from 'vue-router'
import { useVisitorsStore } from '@/shared/store'
import { PurchaseFlowRoutes } from '@/shared/types/router.types'

export const holderInfoGuard: NavigationGuard = (to) => {
  const visitorsStore = useVisitorsStore()

  if (!visitorsStore.visitDate || !visitorsStore.entryValue) {
    return {
      name: PurchaseFlowRoutes.TRAVEL_DATE,
      query: to.query,
    }
  }

  return true
}
